import React from 'react';
import { BaseModal } from '../BaseModal';
import { Colors, Typography, Button } from '@utex/ui-kit';
import { useTranslation } from 'react-i18next';
import { useHistory } from '../../../../hooks/useHistory';

interface Props {
  onRequestClose: () => void;
}

export const FailedModal: React.FC<Props> = ({ onRequestClose }) => {
  const { t } = useTranslation('deposit');

  const history = useHistory();

  return (
    <BaseModal
      icon="fail"
      testId="depositFailureModal"
      title={t('Failure Title')}
      footer={
        <Button isLong={true} view="regular-shadow" onClick={() => history.push('/')}>
          {t('Failure Button Text')}
        </Button>
      }
      backgroungColor={Colors.ut.alertDim}
      onRequestClose={onRequestClose}
    >
      <Typography.Text>{t('Failure Text')}</Typography.Text>
    </BaseModal>
  );
};
